export enum Tokens {
    AVAX = 'AVAX',
    APE = 'APE',
    BTC = 'BTC',
    BNB = 'BNB',
    ADA = 'ADA',
    ETH = 'ETH',
    DOT = 'DOT',
    ARB = 'ARB',
    MATIC = 'MATIC',
    SHIB = 'SHIB',
    DOGE = 'DOGE',
    UNI = 'UNI',
    USDC = 'USDC',
    XRP = 'XRP',
    LINK = 'LINK',
    GOERLI_ETH = 'GoerliETH',
    BLUECHIP = 'blpUSDC',
    ALTCOIN = 'alpUSDC',
    DEGEN = 'dlpUSDC',
    FALLBACK = 'FALLBACK',
}

export type EnabledTokenPairs = [
    Tokens.BTC,
    Tokens.ETH,
    Tokens.BNB,
    Tokens.XRP,
    Tokens.ADA,
    Tokens.MATIC,
    Tokens.DOT,
    Tokens.ARB,
    Tokens.DOGE,
    Tokens.UNI,
    Tokens.LINK
];
